import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { Dropdown, DropdownMenu, DropdownToggle } from "reactstrap";

import { makeStyles } from "@material-ui/core/styles";

import { resetLayoutsToEmpty } from "store/actions/layout.js";
import useAppInsightsHandler from "hooks/useAppInsightsHandler.js";

import { focusDefaultTabInInsights } from "utils/insightsAndAlarmsUtils";
import getLogger from "utils/logger.util.js";
import { getInsightsPagePath } from "utils/router.utils";

import BadgeIcon from "components/BadgeIcon";
import PopoverText from "components/PopoverText";
import ToggleSort from "components/ToggleSort";

import CircularIcon from "assets/Alarms/alert-circular-icon.svg";
import SmartInsightsIllustration from "assets/Insights/smart_insights_illustration.svg";
import InfoIconGreen from "assets/Other/info-icon-green.svg";
import SmartInsightsIcon from "assets/SvgIcon/Header/smart_insights_icon";

import { HEADER_STRINGS, InsightsStrings } from "../../../constants/constantStrings";
import InsightCard from "../../../pages/SystemsAndAlarms/InsightCard";

import "./index.scss";

const useStyles = makeStyles(() => ({
  modal: {
    display: "flex",
    marginTop: 49,
    backgroundColor: "white",
    width: "300px",
    marginLeft: "auto"
  },
  paper: {
    backgroundColor: "white",
    borderRadius: "1px",
    width: "300px",
    minHeight: "110px",
    outline: "none"
  }
}));

export default function SmartInsights() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const Logger = getLogger("SmartInsights");

  const [isInsightsDropdownOpen, setIsInsightsDropdownOpen] = useState(false);
  const state = useSelector(state => state);
  const { hasSystemsAccess } = state.user;
  const insights = state.smartInsights.data;
  const [insightsData, setInsightsData] = useState(insights);
  const getInsightCount = () => (hasSystemsAccess ? (insights.length > 0 ? insights.length : "New") : null);
  const [numberOfInsights, setNumberOfInsights] = useState(getInsightCount());
  const [badgeIconCustomClass, setBadgeIconCustomClass] = useState("");
  const objAppInsights = useAppInsightsHandler();

  useEffect(() => {
    setNumberOfInsights(getInsightCount());
    setInsightsData(insights);
  }, [insights]);

  const onInsightsDropdownClick = () => {
    focusDefaultTabInInsights();
    objAppInsights.trackEvent("insightsDropDownOpen");
    const iconClass = isInsightsDropdownOpen ? "" : "insights-badge-icon-green";
    setBadgeIconCustomClass(iconClass);
    setIsInsightsDropdownOpen(!isInsightsDropdownOpen);
  };

  const toggleSorting = () => {
    objAppInsights.trackEvent("insightsToggleSorting");
    setInsightsData([...insightsData].reverse());
  };

  const onSmartInsightsClicked = () => {
    try {
      dispatch(resetLayoutsToEmpty());
      onInsightsDropdownClick();
    } catch (error) {
      Logger.log("onInsightsDropdownClick", error);
    }
  };

  const popoverDescriptor = <img src={InfoIconGreen} alt="icon" />;
  const popoverDescription = (
    <>
      {InsightsStrings.infoText} <u>{InsightsStrings.contactText}</u>
    </>
  );

  return (
    <>
      <Dropdown className="margin-left-10 pointer" isOpen={isInsightsDropdownOpen} toggle={onInsightsDropdownClick}>
        <DropdownToggle tag="span">
          <BadgeIcon
            customClass={badgeIconCustomClass}
            iconComponent={<SmartInsightsIcon />}
            open={isInsightsDropdownOpen}
            badgeText={numberOfInsights}
            tooltip={InsightsStrings.smartInsights}
          />
        </DropdownToggle>
        <DropdownMenu right className="dropStyleMenu">
          <div className="insights__modal">
            <div className={classes.paper}>
              {insightsData && insightsData[0] && (
                <div>
                  <div className="whiteBackground calculatedValueText border-bottom__light-grey padding15">
                    <span>{HEADER_STRINGS.smartInsights}</span>
                    <PopoverText
                      descriptor={popoverDescriptor}
                      descriptionText={popoverDescription}
                      iconPosition={"110px"}
                      customClass="info-icon-text__width"
                    />
                    <ToggleSort toggleSorting={toggleSorting} />
                  </div>
                  <ul className="whiteBackground flex-column ulActiveInsights">
                    {insightsData &&
                      insightsData.map((item, index) => (
                        <li key={`${item.SystemId}_${index}`}>
                          <Link to={getInsightsPagePath(item.SystemId)} key={`${item.Id}`} onClick={onSmartInsightsClicked}>
                            <InsightCard value={item} isRecomendataionRequired={false} />
                          </Link>
                        </li>
                      ))}
                    <div className="whiteBackground alarm-modal__messagebox grayColor font12">
                      <div>
                        <img className="margin-auto" src={CircularIcon} alt="alert-circular-icon" />
                      </div>
                      <div>{InsightsStrings.insightsModalEndText}</div>
                    </div>
                  </ul>
                </div>
              )}
              {!insights ||
                (!insights[0] && (
                  <div className="insights-modal-noinsights__container">
                    <div className="whiteBackground calculatedValueText padding15">
                      <span className="padding-right-10">{HEADER_STRINGS.smartInsights}</span>
                    </div>
                    <div className="alarms__card--title insights-modal-noinsights__heading">{InsightsStrings.noInsightsHeaderText}</div>
                    <img className="margin-right-5" src={SmartInsightsIllustration} alt="alert-triangle" />
                    <div className="grayText font12 insights-modal-noinsights__text">{InsightsStrings.noInsightsText}</div>
                    <div className="grayText font12 insights-modal-noinsights__text">
                      <u>{InsightsStrings.noInsightsTextSec}</u>
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </DropdownMenu>
      </Dropdown>
    </>
  );
}
